
import { isAPIError } from "@/store/utils";
import { createAppAsyncThunk } from "@/store/thunks/createAppAsyncThunk";
import { withLoader } from "@/store/thunks/thunkWrappers";
import { HTTP_STATUS_CONFLICT } from "@/config/apiConfig";

export const validateSixNameThunk = createAppAsyncThunk<
  undefined, // fulfilled type
  string, // argument type
  { rejectValue: { fieldErrors: { name: string } } }
>(
  "createSix/validateSixName",
  withLoader(
    async(name, { extra, rejectWithValue }) => {
      try {
        await extra.createSixService.validateName(name);
      } catch (error) {
        if (isAPIError(error) && error.status === HTTP_STATUS_CONFLICT) {
          return rejectWithValue({ fieldErrors: { name: "Duplicate name" } });
        }
        throw error; // all other errors are thrown
      }
    }
  )
);

